var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.isLoading || _vm.isI18nLoading,"persistent":"","dark":"","width":"100","overlay-opacity":0.95}},[_c('v-card',{attrs:{"color":"primary"}},[_c('v-card-text',{staticClass:"pt-5 d-flex justify-center"},[_c('v-progress-circular',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }